import React, { HTMLProps } from 'react';
import { Radio } from './ColorButton.styles';

type ColorButtonProps = {
  color: string;
  isSelected?: boolean;
  disabled?: boolean;
} & HTMLProps<HTMLButtonElement>;

export function ColorButton({ color, isSelected = false, disabled = false, onClick }: ColorButtonProps): JSX.Element {
  return <Radio type="button" color={color} isSelected={isSelected} disabled={disabled} onClick={onClick} />;
}
